export const AWARD_CATEGORIES = ['Winner', 'Runner-up'];
export const AWARD_RULE_TEXT = 'Every challenge crowns a Winner, with a Runner-up awarded when five or more entries are received.';
